import { MenuItem } from '@insights-ltd/design-library/components';
import { Select as MuiSelect, SelectChangeEvent } from '@mui/material';
import { SelectProps, SelectTypes } from '../SearchFilter.types';

export const RightSelect = <T extends SelectTypes['labelSelectOptionsType']>({
  value,
  options,
  onChange,
}: SelectProps<T>) => {
  return (
    <MuiSelect
      data-testid="search-filter"
      name="RightSelect"
      inputProps={{
        'data-testid': 'right-select-input',
        'aria-label': 'right filter selector',
      }}
      sx={(theme) => ({
        height: '3.1rem',
        '> div': {
          padding: '13px 16px',
        },
        boxShadow: `inset 0 0 0 1px ${theme.palette.grey[600]}`,
        maxWidth: '270px',
        marginLeft: theme.spacing(1),
      })}
      value={value as T}
      onChange={(event: SelectChangeEvent<T>) => {
        onChange(event.target.value as T);
      }}
    >
      {options?.map(
        ({
          label: optionLabel,
          value: optionValue,
        }: {
          label: string;
          value: T;
        }) => {
          return (
            <MenuItem key={optionLabel} value={optionValue as string}>
              {optionLabel}
            </MenuItem>
          );
        },
      )}
    </MuiSelect>
  );
};
